import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useCurrency } from '../../hooks/useCurrency';
import { definirCotacao, definirSessao, trackLoginSeVoltouDaSteam, trackPageView } from './index';

/**
 * Liga o rastreamento ao estado do site: sessão, cotação e troca de página.
 *
 * Fica montada uma vez, dentro do App. Não desenha nada e não muda nada no
 * site — só lê o que os providers já sabem e repassa ao módulo de tracking.
 */
export function PonteDeRastreamento() {
  const { user, loading, isAdmin } = useAuth();
  const { rate } = useCurrency();
  const { pathname, search } = useLocation();
  const sessaoAvisada = useRef(false);

  // A cotação vem antes da sessão no efeito: eventos presos na fila levam o
  // preço calculado na hora do clique, mas os que saírem daqui em diante já
  // saem em reais.
  useEffect(() => {
    definirCotacao(rate?.rate ?? null);
  }, [rate]);

  useEffect(() => {
    if (loading) return;
    definirSessao({ conhecida: true, administrador: isAdmin });
    if (!sessaoAvisada.current) {
      sessaoAvisada.current = true;
      trackLoginSeVoltouDaSteam(Boolean(user));
    }
  }, [loading, isAdmin, user]);

  // Uma visualização por endereço. O hash não conta: o site não usa âncora
  // como página.
  useEffect(() => {
    trackPageView();
  }, [pathname, search]);

  return null;
}

/** Dispara um evento quando o trecho aparece na tela, uma única vez. */
export function AoAparecer({ disparar }: { disparar: () => void }) {
  const disparado = useRef(false);
  useEffect(() => {
    if (disparado.current) return;
    disparado.current = true;
    disparar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
